import { RequestBuilder } from "../requestBuilder";
import {
  CreateMcpConfigInputSchema,
  McpCatalogResponseSchema,
  McpConfigParamsSchema,
  McpConfigProjectParamsSchema,
  McpConfigSchema,
  McpConfigsResponseSchema,
  McpConnectParamsSchema,
  McpConnectResponseSchema,
  McpMembershipsResponseSchema,
  McpProbeResultSchema,
  McpProjectResponseSchema,
  ProbeMcpServerInputSchema,
  UpdateMcpConfigInputSchema,
} from "./mcp.types";

// GET /integrations/mcp - List the org's registered MCP servers
export const McpConfigsRequestConfig = new RequestBuilder({
  path: () => "/integrations/mcp",
  responseSchema: McpConfigsResponseSchema,
}).withIncludeOrganizationId();

// POST /integrations/mcp?probe=1 - Discover a server's auth method without registering it
export const ProbeMcpServerRequestConfig = new RequestBuilder({
  path: () => "/integrations/mcp",
  bodySchema: ProbeMcpServerInputSchema,
  responseSchema: McpProbeResultSchema,
})
  .withMethod("POST")
  .withQueryParams(() => ({ probe: "1" }))
  .withIncludeOrganizationId();

// POST /integrations/mcp - Register a server with the credentials its probe asked for
export const CreateMcpConfigRequestConfig = new RequestBuilder({
  path: () => "/integrations/mcp",
  bodySchema: CreateMcpConfigInputSchema,
  responseSchema: McpConfigSchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// PATCH /integrations/mcp/configs/{integrationId} - Name, builtin choice, tool selection
export const UpdateMcpConfigRequestConfig = new RequestBuilder({
  paramsSchema: McpConfigParamsSchema,
  path: (params) => `/integrations/mcp/configs/${params.integrationId}`,
  bodySchema: UpdateMcpConfigInputSchema,
  responseSchema: McpConfigSchema,
})
  .withMethod("PATCH")
  .withIncludeOrganizationId();

// DELETE /integrations/mcp/configs/{integrationId} - Remove the server from the org
export const DeleteMcpConfigRequestConfig = new RequestBuilder({
  paramsSchema: McpConfigParamsSchema,
  path: (params) => `/integrations/mcp/configs/${params.integrationId}`,
})
  .withMethod("DELETE")
  .withIncludeOrganizationId();

// POST /integrations/mcp/configs/{integrationId}/projects/{projectId} - Deploy to a project
export const AddMcpConfigProjectRequestConfig = new RequestBuilder({
  paramsSchema: McpConfigProjectParamsSchema,
  path: (params) => `/integrations/mcp/configs/${params.integrationId}/projects/${params.projectId}`,
  responseSchema: McpMembershipsResponseSchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// DELETE /integrations/mcp/configs/{integrationId}/projects/{projectId} - Undeploy from a project
export const RemoveMcpConfigProjectRequestConfig = new RequestBuilder({
  paramsSchema: McpConfigProjectParamsSchema,
  path: (params) => `/integrations/mcp/configs/${params.integrationId}/projects/${params.projectId}`,
  responseSchema: McpMembershipsResponseSchema,
})
  .withMethod("DELETE")
  .withIncludeOrganizationId();

// POST /integrations/mcp/configs/{integrationId}/refresh-tools - Re-run tools/list into the cache, with the caller's grant for oauth servers
export const RefreshMcpToolsRequestConfig = new RequestBuilder({
  paramsSchema: McpConfigParamsSchema,
  path: (params) => `/integrations/mcp/configs/${params.integrationId}/refresh-tools`,
  responseSchema: McpConfigSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

// GET /integrations/mcp/configs/{integrationId}/connect?returnUrl= - Start the caller's own OAuth grant in this project
export const ConnectMcpRequestConfig = new RequestBuilder({
  paramsSchema: McpConnectParamsSchema,
  path: (params) => `/integrations/mcp/configs/${params.integrationId}/connect`,
  responseSchema: McpConnectResponseSchema,
})
  .withQueryParams((params) => ({ returnUrl: params.returnUrl }))
  .withIncludeProjectId();

// DELETE /integrations/mcp/configs/{integrationId}/connection - Drop the caller's own grant in this project
export const DisconnectMcpRequestConfig = new RequestBuilder({
  paramsSchema: McpConfigParamsSchema,
  path: (params) => `/integrations/mcp/configs/${params.integrationId}/connection`,
})
  .withMethod("DELETE")
  .withIncludeProjectId();

// GET /integrations/mcp/project - Servers deployed to the project, split by whether the caller can call them
export const McpProjectConfigsRequestConfig = new RequestBuilder({
  path: () => "/integrations/mcp/project",
  responseSchema: McpProjectResponseSchema,
}).withIncludeProjectId();

// GET /integrations/mcp/catalog - The curated server list with each entry's last probe outcome
export const McpCatalogRequestConfig = new RequestBuilder({
  path: () => "/integrations/mcp/catalog",
  responseSchema: McpCatalogResponseSchema,
}).withIncludeOrganizationId();
